import React from 'react';
import { Button } from '~/components/ui/button';

type Props = {
  value: string;
  onFilterChange: (value: string) => any;
  letterStyle?: React.CSSProperties;
};
export type AlphabetFilterProps = React.HTMLAttributes<HTMLDivElement> & Props;

export function AlphabetFilter({
  value,
  onFilterChange,
  letterStyle = {},
  ...props
}: AlphabetFilterProps) {
  const handleClick = (letter: string) => (event: React.MouseEvent) => {
    event.preventDefault();
    onFilterChange(letter);
  };

  const alphabet = 'abcdefghijklmnopqrstuvwxyzæøå'.split('');

  return (
    <div {...props} className={props.className ?? 'text-center space-x-0'}>
      <div className="join">
        {alphabet.map(letter => (
          <Button
            key={letter}
            type="button"
            color={letter === value ? 'warning' : undefined}
            size="md"
            onClick={handleClick(letter)}
            className="px-2 py-0 join-item"
          >
            {letter.toUpperCase()}
          </Button>
        ))}
      </div>
    </div>
  );
}
